const { red6 } = require("./lib/helpers/colors");
var pym = require("./lib/pym");
require("./lib/webfonts");
var { COLORS, classify, makeTranslate, formatStyle } = require("./lib/helpers");


// Global config
var COLOR_BINS = [
  -100,-90, -80, -70, -60, -50, -40, -30, -20, -10, 
  -0.0001,  // Lower bound for zero bin
  0,        // Zero bin center
  0.0001,   // Upper bound for zero bin
  0.0002,   // Start of positive bins
  10, 20, 30, 40, 50, 60, 70, 80, 90, 100
];
// Create an array of evenly spaced numbers for the x-axis/COLOR_BINS
// const binRange = {
//   min: -80,
//   max: 150,
//   interval: 10,
// };

// const binNumbers = [];
// for (let i = binRange.min; i <= binRange.max; i += binRange.interval) {
//   binNumbers.push(i);
// }

// // Global config
// var COLOR_BINS = binNumbers

//figure out how to marry the colors to the actual values
var COLOR_RANGE = [
  "#128B24", // -90 bin
  "#128B24", // -80 bin
  "#128B24", // -70 bin
  "#128B24", // -60 bin
  "#128B24", // -50 bin
  "#128B24", // -40 bin
  "#1a9850", // -30 bin
  "#66bd63", // -20 bin
  "#a6d96a", // -10 bin
  "#d6e0b2", // -0.0001 (approaching zero from negative)
  "#bbb8b8", // 0 (exact zero)
  "#bbb8b8", // 0.0001 (approaching zero from positive)
  "#dc755b", // 2.99:1 - For large text only
  "#dc755b", // 3.78:1 - For large text only
  "#C84E4E", // 4.51:1 - Meets WCAG AA for normal text
  "#BB4141", // 5.32:1 - Meets WCAG AA for normal text
  "#AE3636", // 6.21:1 - Meets WCAG AA for normal text
  "#A12C2C", // 7.21:1 - Meets WCAG AAA for normal text
  "#942323", // 8.32:1 - Meets WCAG AAA for normal text
  "#871A1A", // 9.58:1 - Meets WCAG AAA for normal text
  "#7A1111", // 10.96:1 - Meets WCAG AAA for normal text
  "#6D0808", // 12.44:1 - Meets WCAG AAA for normal text
  "#600000"  
];

// Global vars
var pymChild = null;

var renderBlockHistogram = require("./renderBlockHistogram");

// Initialize the graphic.
var onWindowLoaded = function() {
  var binned = formatData(window.DATA);
  render(binned);

  window.addEventListener("resize", () => render(binned));

  pym.then(child => {
    pymChild = child;
    pymChild.sendHeight();
  });
};

// Format graphic data for processing by D3.
var formatData = function(data) {
  const numBins = COLOR_BINS.length - 1;
  const binnedData = Array(numBins).fill().map(() => []);
  
  data.forEach(d => {
    if (d.amt != null) {
      const item = d.Item;
      const amt = d.amt;
      
      // Special case for exact zero
      if (amt === 0) {
        const zeroBinIndex = COLOR_BINS.findIndex(b => b === 0);
        if (zeroBinIndex !== -1) {
          binnedData[zeroBinIndex].unshift(item);
        }
        return;
      }

      // Special handling for values very close to zero
      if (Math.abs(amt) <= 0.0001) {
        const zeroBinIndex = COLOR_BINS.findIndex(b => b === 0);
        if (zeroBinIndex !== -1) {
          binnedData[zeroBinIndex].unshift(item);
        }
        return;
      }

      // For all other values, find the appropriate bin
      for (let i = 0; i < numBins; i++) {
        // Skip the special zero-related bins when looking for regular intervals
        if (COLOR_BINS[i] === -0.0001 || COLOR_BINS[i] === 0 || COLOR_BINS[i] === 0.0001) {
          continue;
        }
        
        // Check if value falls in this bin's range
        const binStart = COLOR_BINS[i];
        const binEnd = COLOR_BINS[i + 1];
        
        if (amt >= binStart && amt < binEnd) {
          binnedData[i].unshift(item);
          
          // Debug logging for 0-10 range
          if (amt > 0 && amt <= 10) {
            console.log(`Binned ${item} (${amt}) into bin ${binStart}-${binEnd}`);
          }
          
          break;
        }
      }
    }
  });
  
  return binnedData;
};

// Render the graphic(s). Called by pym with the container width.
var render = function(data) {
  // Render the chart!
  var container = "#block-histogram";
  var element = document.querySelector(container);
  var width = element.offsetWidth;
  renderBlockHistogram({
    container,
    width,
    data,
    bins: COLOR_BINS,
    colors: COLOR_RANGE,
    labelColumn: "item",
    valueColumn: "amt", 
    originalData: window.DATA
  });

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

// Initially load the graphic
// (NB: Use window.load to ensure all images have loaded)
window.onload = onWindowLoaded;
